export enum UserRightsMessages {
  launcher = "userRights.tab.launcher",
  rightsControl = "userRights.tab.rightsControl",
  selectTenant = "userRights.tab.selectTenant",
  userControl = "userRights.tab.userControl",
  roleDashboardTabCaption = "userRights.tab.roleDashboardTabCaption",
  roleDashboardPageTitle = "userRights.page.roleDashboardPageTitle",
  createRoleTabCaption = "userRights.tab.createRoleTabCaption",
  editRoleTabCaption = "userRights.tab.editRoleTabCaption",
  createUserTabCaption = "userRights.tab.createUserCaption",
  editUserTabCaption = "userRights.tab.editUserCaption",
  usersWithoutRole = "userRights.usersWithoutRole",
  noRoleOrUserRegistered = "userRights.noRoleOrUserRegistered",
  noSuiteAllowed = "userRights.noSuiteAllowed",
  memberCount = "userRights.memberCount",
  userCount = "userRights.userCount"
}

export interface TranslationUserRightsMessages {
  [UserRightsMessages.launcher]: string;
  [UserRightsMessages.rightsControl]: string;
  [UserRightsMessages.selectTenant]: string;
  [UserRightsMessages.userControl]: string;
  [UserRightsMessages.roleDashboardTabCaption]: string;
  [UserRightsMessages.roleDashboardPageTitle]: string;
  [UserRightsMessages.createRoleTabCaption]: string;
  [UserRightsMessages.editRoleTabCaption]: string;
  [UserRightsMessages.createUserTabCaption]: string;
  [UserRightsMessages.editUserTabCaption]: string;
  [UserRightsMessages.usersWithoutRole]: string;
  [UserRightsMessages.noRoleOrUserRegistered]: string;
  [UserRightsMessages.noSuiteAllowed]: string;
  [UserRightsMessages.memberCount]: string;
  [UserRightsMessages.userCount]: string;
}